import { flow } from 'fp-ts/function';
import { get } from 'lodash/fp';

import { Availability, AvailabilityValue } from '../types/data';

import { getAvailabilityHash } from './getAvailabilityHash';

type VoucherCode = string | undefined;

interface AvailabilityOptions {
    availability: Availability;
    startDate: string;
    endDate: string;
    enterpriseId: string;
    voucherCode: VoucherCode;
    startTimeUtc?: string;
    endTimeUtc?: string;
}

type GetAvailabilityValue = (options: AvailabilityOptions) => AvailabilityValue;

export const getAvailabilityValue: GetAvailabilityValue = ({
    availability,
    startDate,
    endDate,
    enterpriseId,
    voucherCode,
    startTimeUtc,
    endTimeUtc,
}) =>
    availability[
        getAvailabilityHash({
            startDate: startTimeUtc ?? startDate,
            endDate: endTimeUtc ?? endDate,
            enterpriseId,
            voucherCode,
        })
    ] ?? {};
interface AvailabilityCategoryOptions extends AvailabilityOptions {
    categoryId: string;
}

const getCategoryAvailability = ({ categoryId, ...options }: AvailabilityCategoryOptions) =>
    flow(getAvailabilityValue, get(['categories', categoryId]))(options);

export const getCategoryAvailableCount = flow<[AvailabilityCategoryOptions], AvailabilityValue, number>(
    getCategoryAvailability,
    get('availableCount')
);
